












import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import FaqItem from "./FaqItem.vue";
import LandingContainer from "../LandingContainer";

export default defineComponent({
  name: "FaqBlock",
  components: { FaqItem, LandingContainer },
  setup() {
    const items = [
      {
        question: $t("Does Wide have an application?"),
        answer: $t("Wide currently has a web application that can be saved by scanning the QR code on our webpage."),
      },
      {
        question: $t("How can I be discovered?"),
        answer: $t(
          "Wide works with over 2500 unique brands, creators can be discovered through our in app discovery feed."
        ),
      },
      {
        question: $t("Is explicit content allowed?"),
        answer: $t("Wide does not allow any sexually explicit content."),
      },
      {
        question: $t("What payment methods does Wide accept?"),
        answer: $t(
          "We accept all major credit cards Visa, Master Card, AMEX through our secured check out system powered via Stripe."
        ),
      },
      {
        question: $t("How much can I earn on Wide?"),
        answer: $t(
          "Your earning potential is unlimited, by sharing your Wide link to your free social media profiles you can attract new subscribers."
        ),
      },
    ];

    return {
      items,
    };
  },
});
